<form [formGroup]="formGroup">
  <ui-page-flyer [data]="data" [logPrefix]="logPrefix" [allowVerboseDebugMode]="allowVerboseDebugMode">
    <ui-content-display-form custom-content-section [data]="fromDataFormContent" (formValuesChanged)="formValueChanged($event)"> </ui-content-display-form>
  </ui-page-flyer>
</form>
